import type { FaireProductEntity } from "../../entity_types/product";

export const p_73kh78gv76: FaireProductEntity = {
  token: "p_73kh78gv76",
  type: "product",
  name: "A Little Note to Say a Big Thank You - Greeting Card",
  brandToken: "b_c7r7p3a7zr",
  brandName: "Balsam Paper Co",
  imageUrl:
    "https://cdn.faire.com/fastly/6ceb5f58453b8ef7fb40ef44a8620b6b2cfe594d08e3dfa5ee9be62fb3186d4d.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23ef7f6576a918e74dc8c4cc987667e9c0a2a3f14f0054e9cab14e3615d6d5fd.webp",
    "https://cdn.faire.com/fastly/ea8729230b8d372aef92e6a1dedd86f385eba7ce5a6d7c65f3b8ced6bc877082.webp",
  ],
  priceDollars: 2.5,
  description:
    "The perfect card to say a special thank you! This simple and elegant design is great for any occasion. The inside is blank with plenty of space for your personalized note.\n\n• 100% Recycled White Cardstock Paper (eco-friendly!)\n• Blank Kraft Brown Paper Envelope\n• (blank inside for your personal note)\n• Card: 5.5 in x 4.25 in\n• Envelope: 5.75 in x 4.5 in\n\nThese cards made in Ontario. I hope my passion for creating paper goods can bring a smile to your face.",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:21.539Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
